// src/api.js
import axios from 'axios'
const baseUrl = 'https://ybb.xinyunit.com/api'
import config from './config/config'
import { formatTimeUuid, getToken, aesEncrypt, removeToken } from './utils/utils'
import { useRouter } from 'vue-router'

const router = useRouter()

const api = axios.create({
  baseURL: baseUrl,
  timeout: 10000
})

// 公众号端-注册或登录
export function registerOrLogin({ weixinCode, agreementFlag }) {
  return doPost('/broadcast.xy/mp/registerOrLogin', { weixinCode, agreementFlag })
}

// 公众号端-绑定手机号
export function bindPhone({ phone }) {
  return doPost('/broadcast.xy/mp/bindPhone', { phone })
}

// 公众号端-获取家长的孩子列表
export function getParentChildren() {
  return doPost('/broadcast.xy/mp/getParentChildren', {})
}

// 公众号端-获取老师的班级信息
export function getTeacherClass() {
  return doPost('/broadcast.xy/mp/getTeacherClass', {})
}

// 公众号端-家长接送孩子
export function pickUpChild({ studentId }) {
  return doPost('/broadcast.xy/mp/pickUpChild', { studentId })
}

// 公众号端-获取接送孩子的记录（即消息详情）
export function getPickUpChildRecord({ pickUpRecordId }) {
  return doPost('/broadcast.xy/mp/getPickUpChildRecord', { pickUpRecordId })
}

export async function doPost(url, data) {
  var reqTime = formatTimeUuid(new Date())
  var clientType = "3"; //1:ios, 2:android 3:miniProgram
  var appName = config.appName;
  var version = config.version;
  var ip = "192.168.1.1";
  var token = getToken() ?? "";
  var signStr = "reqTime=" + reqTime + "&clientType=" + clientType + "&appName=" + appName + "&version=" + version + "&ip=" + ip + "&token=" + token;


  let headers = {
    "reqTime": reqTime,
    "clientType": clientType,
    "appName": appName,
    "version": version,
    "ip": ip,
    "sign": aesEncrypt(signStr),
    "content-type": "application/json",
    "token": token,
  }

  let reqData = {
    reqData: aesEncrypt(JSON.stringify(data))
  }

  console.log("================")
  console.log(JSON.stringify(data))
  console.log('headers: ' + JSON.stringify(headers))
  console.log("================")

  return await api.post(url, reqData, {
    headers: headers
  }).then(response => {
    // 检查响应码
    if (response.data && response.data.respCode !== "000000") {

      const error = new Error(response.data.respMsg || '请求失败')
      error.respCode = response.data.respCode
      error.respMsg = response.data.respMsg

      if (response.data.respCode === "000018") {
        removeToken()
        router.replace('/login')
        throw error
      }

      // 直接弹出错误消息
      alert(response.data.respMsg || '请求失败')

      throw error
    }
    return response
  }).catch(err => {
    console.log('err: ' + JSON.stringify(err))
    throw err
  })
}